import { apiGet, apiPost } from "../../utils"

export function getUserBankDetailsAPI(data) {
    return apiGet('/api/getUserBankDetails', data)
}

export function addBankDetailsAPI(data) {
    return apiPost('/api/addBankDetails', data)
}

export function withdrawMoneyAPI(data) {
    return apiPost('/api/withdrawMoney', data)
}

export function getUserAPI() {
    return apiGet('/api/getUserDetails')
}

export function getPayoutHistoryAPI() {
    return apiGet('/api/getPayoutHistory')
}
